/* ============================================================================
   Pop-in promo — carte flottante non-bloquante (façon Sézane)
   ----------------------------------------------------------------------------
   - Apparition immédiate (delay=0) ou après un délai.
   - Fermeture (croix) mémorisée par campagne via localStorage → ne réapparaît
     plus tant que l'identifiant de campagne ne change pas.
   - Dans l'éditeur de thème (Shopify.designMode) : on ignore la mémorisation et
     on affiche toujours, pour que la cliente puisse prévisualiser.
   Vanilla JS, écoute déléguée. Aucun lien avec le theme.js minifié.
   ============================================================================ */
(function () {
  'use strict';

  function isEditor() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function storageKey(el) {
    return 'theme:promo-pop-in:' + (el.getAttribute('data-campaign') || 'promo');
  }

  function isDismissed(el) {
    try {
      return localStorage.getItem(storageKey(el)) === 'dismissed';
    } catch (e) {
      return false;
    }
  }

  function rememberDismiss(el) {
    try {
      localStorage.setItem(storageKey(el), 'dismissed');
    } catch (e) {
      /* localStorage indisponible (navigation privée…) : on ferme quand même */
    }
  }

  function reveal(el) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.add('is-visible');
      });
    });
  }

  function close(el) {
    el.classList.remove('is-visible');
    if (!isEditor()) {
      rememberDismiss(el);
    }
    window.setTimeout(function () {
      el.classList.add('is-dismissed');
    }, 400);
  }

  /* Déplace le pop-in juste APRÈS le diaporama, dans le flux de <main>.
     - Desktop : la carte est en position:fixed → sa position DOM n'a aucun impact.
     - Mobile : la carte est en position:static → elle s'affiche ainsi SOUS le
       diaporama (et non en haut de page). On déplace la section entière
       (#shopify-section-…) pour conserver le <style> scopé (offsets, taille titre). */
  function placeUnderSlideshow(el) {
    var main = document.getElementById('main');
    if (!main) {
      return;
    }
    var node = el.closest('.shopify-section') || el;
    var slideshow = main.querySelector('.shopify-section--slideshow');
    var anchor = slideshow || main.firstElementChild;
    if (!anchor || anchor === node || anchor.nextElementSibling === node) {
      return;
    }
    anchor.parentNode.insertBefore(node, anchor.nextElementSibling);
  }

  function init(el) {
    if (!el || el.dataset.ppiInit === '1') {
      return;
    }
    el.dataset.ppiInit = '1';

    placeUnderSlideshow(el);

    var closeBtn = el.querySelector('.promo-pop-in__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        close(el);
      });
    }

    if (!isEditor() && isDismissed(el)) {
      return; /* déjà fermé par ce visiteur → on laisse masqué */
    }

    var delay = parseInt(el.getAttribute('data-delay'), 10);
    if (!delay || delay < 0 || isEditor()) {
      delay = 0;
    }

    if (delay > 0) {
      window.setTimeout(function () {
        reveal(el);
      }, delay * 1000);
    } else {
      reveal(el);
    }
  }

  function initAll() {
    var nodes = document.querySelectorAll('.promo-pop-in');
    for (var i = 0; i < nodes.length; i++) {
      init(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Éditeur de thème : re-init quand la section est rechargée */
  document.addEventListener('shopify:section:load', initAll);
})();
